import React, { useEffect, useState } from 'react'
import styles from './index.module.css'
import Header from '../components/header'
import ApiService from '../ApiService'
import { LogResponse } from '../models'
import Loading from '../components/loading'
import { parseDate } from '../utils/parseDate'

export default function Logs() {
  const [page, setPage] = useState<number>(1)
  const [lastFetched, setLastFetched] = useState<number>()
  const [fetching, setFetching] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [logs, setLogs] = useState<LogResponse[]>([])

  const tableColumns = [
    { key: 'timestamp', label: 'Horário', className: styles.timeColumn },
    { key: 'author', label: 'Autor', className: styles.authorColumn },
    { key: 'action', label: 'Ação', className: styles.actionColumn },
    { key: 'object', label: 'Imóvel/Usuário', className: styles.objectColumn },
  ]

  const handleGetLogs = async (pageNumber: number) => {
    setIsLoading(true)
    try {
      const response = await ApiService.getLogs('all', pageNumber) as LogResponse[]
      setLogs((currentLogs) => pageNumber !== 1 ? [...currentLogs, ...response] : response)
      setLastFetched(response.length)
    } catch (error: any) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleScroll = async (e: any) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target
    const bufferHeight = 50

    if (
      Math.floor(scrollTop + clientHeight) >= Math.floor(scrollHeight) - bufferHeight &&
      lastFetched &&
      lastFetched >= 100 &&
      !fetching
    ) {
      setFetching(true)
      await handleGetLogs(page + 1)
      setPage((currentPage) => currentPage + 1)
      setFetching(false)
    }
  }

  useEffect(() => {
    void handleGetLogs(1)
  }, [])

  return (
    <div className={styles.background}>
      <Header />
      <p className={styles.pageTitle}>Logs</p>
      <div className={styles.tableShell}>
        <div className={styles.tableViewport} onScroll={handleScroll}>
          <table className={styles.table}>
            <thead className={styles.tableHead}>
              <tr className={styles.headerRow}>
                {tableColumns.map((column) => (
                  <th key={column.key} className={column.className}>
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {logs.map((log) => (
                <tr key={log.id} className={styles.dataRow}>
                  <td className={styles.timeColumn} data-label='Horário'>
                    <span className={styles.primaryText}>{parseDate(log.timestamp, true, false)}</span>
                  </td>
                  <td className={styles.authorColumn} data-label='Autor'>
                    <span className={styles.primaryText}>{`${log.actor_first_name} ${log.actor_last_name}`}</span>
                  </td>
                  <td className={styles.actionColumn} data-label='Ação'>
                    <span className={styles.actionBadge}>{log.action}</span>
                  </td>
                  <td className={styles.objectColumn} data-label='Imóvel/Usuário'>
                    <span className={styles.primaryText}>{log.object_detail}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {isLoading && (
            <div className={styles.loadingContainer}>
              <Loading />
            </div>
          )}
          {!isLoading && logs.length === 0 && (
            <div className={styles.emptyState}>
              Nenhum log encontrado.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
